import React from "react";
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import CircularProgress from '@material-ui/core/CircularProgress';
import { grey } from '@material-ui/core/colors';
import Button from 'components/CustomButtons/Button.jsx';
import { AuthConsumer } from '../../../auth/AuthContext'; 

const styles = {
    root: {
      height: 48,
      display: 'flex',
      justifyContent: 'space-between',
      position: 'relative',
    },
    iconButton: {
      opacity: 0.54,
      transform: 'scale(1, 1)',
      transition: 'transform 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
    },
    iconButtonHidden: {
      transform: 'scale(0, 0)',
      '& > $icon': {
        opacity: 0,
      },
    },
    iconButtonDisabled: {
      opacity: 0.38,
    },
    icon: {
      opacity: 0.54,
      transition: 'opacity 200ms cubic-bezier(0.4, 0.0, 0.2, 1)',
    },
    input: {
      width: '110%',
    },
    commentContainer: {
      margin: 'auto 16px',
      width: 'calc(100% - 48px - 32px)',
    },
    addCommentButton: {
        marginLeft: 12,
        marginRight: 35,
    }
};

class CommentSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
        };
    }

    handleInput = e => {
        const value = e.target.value;
        this.setState({ value });
    }

    handleCancel = () => {
        this.setState({ value: '' });
    }
    
    render() {
        const {
            className,
            classes,
            style,
            loading,
            placeholder,
            onRequestAddComment,
            role
        } = this.props;
        const { value } = this.state;

        return (
            <AuthConsumer>
                {({ isAuthorized }) =>
                    isAuthorized(role) ? (
                        <React.Fragment>
                            <Paper
                                className={classNames(classes.root, className)}
                                style={style}
                                elevation={1}
                            >
                                <div className={classes.commentContainer}>
                                    <Input
                                        placeholder={placeholder}
                                        value={value}
                                        onChange={this.handleInput}
                                        fullWidth
                                        className={classes.input}
                                        disableUnderline
                                    />
                                </div>
                                <IconButton
                                    onClick={this.handleCancel}
                                    classes={{
                                        root: classNames(classes.iconButton, {
                                        [classes.iconButtonHidden]: value === '' || loading,
                                        }),
                                        disabled: classes.iconButtonDisabled,
                                    }}
                                >
                                    <ClearIcon
                                        style={{ color: grey[500] }}
                                        classes={{ root: classes.icon }}
                                    />
                                </IconButton>
                                {loading ? (
                                <CircularProgress
                                    style={{ position: 'absolute', top: 12, right: 10 }}
                                    color="primary"
                                    size={25}
                                />
                                ) : null}
                            </Paper>
                            <Button
                                color={loading ? undefined : 'success'}
                                onClick={async () => {
                                    await onRequestAddComment(value);
                                    this.setState({ value: '' });
                                }}
                                disabled={loading || !value || !value.trim()}
                                className={classes.addCommentButton}
                            >
                                Kommentieren
                            </Button>
                        </React.Fragment>
                    ) : null
                }
            </AuthConsumer>
        );
    }
}

CommentSection.defaultProps = {
    className: '',
    placeholder: 'Schreibe einen Kommentar...',
    style: null,
    value: '',
  };

CommentSection.propTypes = {
    /** Override or extend the styles applied to the component. */
    classes: PropTypes.object.isRequired,
    /** Custom top-level class */
    className: PropTypes.string,
    /** Sets placeholder text for the embedded text field. */
    placeholder: PropTypes.string,
    /** Override the inline-styles of the root element. */
    style: PropTypes.object,
    loading: PropTypes.bool,
};

export default withStyles(styles)(CommentSection);



// WEBPACK FOOTER //
// ./src/views/skidata/components/CommentSection.jsx